var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twitter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg",
    d: "M0 15.9995C0 24.8361 7.16344 31.9995 16 31.9995C24.8366 31.9995 32 24.8361 32 15.9995C32 7.16296 24.8366 -0.000488281 16 -0.000488281C7.16344 -0.000488281 0 7.16296 0 15.9995Z",
    fill: "#1DA1F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "twitter_2",
    d: "M24 10.9995C23.4 11.2995 22.8 11.3995 22.1 11.4995C22.8 11.0995 23.3 10.4995 23.5 9.69951C22.9 10.0995 22.2 10.2995 21.4 10.4995C20.8 9.89951 19.9 9.49951 19 9.49951C16.9 9.49951 15.3 11.4995 15.8 13.4995C13.1 13.3995 10.7 12.0995 9 10.0995C8.1 11.5995 8.6 13.4995 10 14.4995C9.5 14.4995 9 14.2995 8.5 14.0995C8.5 15.5995 9.6 16.9995 11.1 17.3995C10.6 17.4995 10.1 17.5995 9.6 17.4995C10 18.7995 11.2 19.7995 12.7 19.7995C11.5 20.6995 9.7 21.1995 8 20.9995C9.5 21.8995 11.2 22.4995 13 22.4995C19.1 22.4995 22.5 17.3995 22.3 12.6995C23 12.2995 23.6 11.6995 24 10.9995Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.bddb515083cbc41ea98ef2e721a2340d.svg";
export { ForwardRef as ReactComponent };